module.exports = __webpack_public_path__ + "img/d68a319355abf22d89da96c1972710c3.png";